<template>
  <div>
    <InfosCommercial/>
    <ActionsDownload/>
    <Concurrent/>
    <ActionsModal v-if="afficheBloc"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Concurrent from '@/components/portail/concurrent/concurrent';
import InfosCommercial from './blocInfos/InfosCommercial';
import ActionsDownload from './blocInfos/ActionsDownload';
import ActionsModal from './blocInfos/ActionsModal';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: {
    InfosCommercial,
    ActionsDownload,
    ActionsModal,
    Concurrent,
  },
  computed: {
    ...Recommandation.mapGetters({
      getPdv: 'pdv',
    }),
    afficheBloc() {
      if (this.getPdv.enseigne === 'GEANT CASINO') return false;
      if (this.getPdv.enseigne === 'FRANPRIX') return false;
      if (this.getPdv.enseigne === 'SUPERMACHE CASINO') return false;
      else return true;
    }
  },
};
</script>

<style>

</style>